import React from 'react';
import {ItemProps} from '../ItemProps';
import {ItemGridTile} from './ItemGridTile';
import {ItemsGridContainer} from './ItemGrid.style';
import {generateIdentifier} from '../../../utils/IdentityUtils';

/**
 * @name ItemGrid
 * @description
 * Component to show download items (folder/file) for the grid visualisation.
 */
export const ItemGrid: React.VFC<ItemProps> = (props) => {
    return (
        <ItemsGridContainer id={generateIdentifier()}>
            {props.items.map(item => (
                <ItemGridTile key={item.id}
                              isMobileView={props.isMobileView}
                              isMobileResolution={props.isMobileResolution}
                              layoutView={props.layoutView}
                              item={item}
                              language={props.language}
                              defaultLocale={props.defaultLocale}
                              editMode={props.editMode}
                              publicOnlyAccess={props.publicOnlyAccess}
                              isFavorite={props.favoriteItems.includes(item.id)}
                              labelData={props.labelData ?? []}
                              onEdit={() => props.onEdit(item)}
                              onDelete={() => props.onDelete(item)}
                              onDownload={() => props.onDownload(item)}
                              onDetails={() => props.onDetails(item)}
                              onFavorite={() => props.onFavorite(item)}
                              onPreview={() => props.onPreview(item)}
                              onCopyUrl={() => props.onCopyUrl(item)}
                              onClick={() => props.onClick(item)}/>
            ))}
        </ItemsGridContainer>
    );
};
